import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import FormsList from "./FormsList";
import VehicleServiceUpdate from "./VehicleServiceUpdate";
import VehicleServiceUpdateSuccess from "./VehicleServiceUpdateSuccess";
import RideAlong from "./RideAlong";
import FuelCard from "./FuelCard";
import OvertimeRequest from "./OvertimeRequest";
import ReceiptSubmission from "./ReceiptSubmission";
import ShiftClosing from "./ShiftClosing";
import ShiftOverlapAuthorization from "./ShiftOverlapAuthorization";
import config from "config/configProvider";

export const FormsRouter: FC<{}> = () => {
  const vehicleServiceUpdateEnabled = config.FormsEnabled_VehicleServiceUpdate === "true";
  const overtimeRequestEnabled = config.FormsEnabled_OvertimeRequest === "true";
  const receiptSubmissionEnabled = config.FormsEnabled_ReceiptSubmission === "true";
  const fuelCardEnabled = config.FormsEnabled_FuelCard === "true";
  const rideAlongEnabled = config.FormsEnabled_RideAlong === "true";
  const shiftClosingEnabled = config.FormsEnabled_ShiftClosing === "true";
  const shiftOverlapAuthorizationEnabled = config.FormsEnabled_ShiftOverlapAuthorization === "true";

  return (
    <Routes>
      <Route index element={<FormsList />} />
      {vehicleServiceUpdateEnabled && (
        <Route path="vehicle-service-update" element={<VehicleServiceUpdate />} />
      )}
      {vehicleServiceUpdateEnabled && (
        <Route path="vehicle-service-update/success" element={<VehicleServiceUpdateSuccess />} />
      )}
      {rideAlongEnabled && <Route path="ride-along" element={<RideAlong />} />}
      {fuelCardEnabled && <Route path="fuel-card" element={<FuelCard />} />}
      {overtimeRequestEnabled && <Route path="overtime-request" element={<OvertimeRequest />} />}
      {receiptSubmissionEnabled && (
        <Route path="receipt-submission" element={<ReceiptSubmission />} />
      )}
      {shiftClosingEnabled && <Route path="shift-closing" element={<ShiftClosing />} />}
      {shiftOverlapAuthorizationEnabled && (
        <Route path="shift-overlap-authorization" element={<ShiftOverlapAuthorization />} />
      )}
    </Routes>
  );
};
